export default "__VITE_ASSET__bc3dff66__"